<template>
  <div class="ride-booking-map">
    <div class="map-wrapper" id="ride-booking-map">
      <!-- :class="{ 'is-tall': isTall }" -->
      <div :id="mapID" class="map">
        <div class="leaflet-top leaflet-right">
          <div class="center-btn button is-white is-rounded" @click="toggleFit">
            <i class="fa fa-expand" />
          </div>
          <div class="center-btn button is-white is-rounded" @click="recenter">
            <i class="fa fa-crosshairs" :class="{ 'fa-spin': spin }" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sounds } from "@/functions";
// import geo from "@/geo";
import L from "leaflet";
import "leaflet.awesome-markers";
import "leaflet.marker.slideto";
import vehicles from "@/vehicles";

export default {
  name: "RideBookingMap",
  props: {
    t: Object,
    isTall: Boolean,
  },
  watch: {
    // isTall: function (newVal, oldVal) {
    isTall() {
      this.shiftMapUpDown(); // this.redrawMap();
    },
    t() {
      //   console.log("t updated", this.t);
      this.drawDriver(); // draws or updates
    },
  },
  data() {
    return {
      mapID: "ride-booking-map-map",
      map: null,
      layer: null, // main layer
      userMarker: null,
      driverMarker: null,
      driverLine: null,
      pickupMarker: null,
      dropoffMarker: null,
      slideOpts: { duration: 10000, keepAtCenter: false },
      spin: false,
      fit: false, // toggle fit
      //   popupWide: { closeButton: false, maxWidth: 300, autoPan: false },
      popupNarrow: { closeButton: false, maxWidth: 100, autoPan: false },
      driverGPSRemindedAt: new Date(),
    };
  },
  computed: {
    pickup() {
      return this.t.data.pickup_stop;
    },
    dropoff() {
      return this.t.data.dropoff_stop;
    },
    workflow() {
      return this.t.workflow;
    },
    vehicleIcon() {
      if (!this.workflow) return null;
      var iconName = this.workflow.data.icon || this.workflow.name;
      return vehicles.img(iconName);
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  mounted() {
    this.initMap();
    this.watchUserLocation();
    if (this.t.state !== "initiated") sounds("safe");
    setTimeout(() => this.fitToState(), 1000);
  },
  // activated() doesn't run the first time, only mounted() runs
  activated() {
    this.updateUserMarker();
    this.drawDriver(); // draws or updates
    // this.centerUserMarker();
    this.fitToState(); // fit to different things depending on booking state
  },
  deactivated() {
    this.map.closePopup();
  },
  methods: {
    fitToState() {
      console.log("fitToState");
      var markers = [this.userMarker];
      switch (this.t.state) {
        case "rejected":
        case "cancelled_by_driver":
        case "no_show":
        case "timed_out":
        case "alighted":
        case "initiated":
          markers = markers.concat([this.pickupMarker, this.dropoffMarker]);
          break;
        case "confirmed":
        case "driver_arrived":
          markers = markers.concat([this.pickupMarker, this.driverMarker]);
          break;
        case "enroute":
          markers = markers.concat([this.dropoffMarker, this.driverMarker]);
          break;
      }
      var group = new L.featureGroup(markers);
      var padding = { padding: [60, 60] };
      this.map.fitBounds(group.getBounds(), padding);
      //   this.map.flyToBounds(group.getBounds(), padding);
    },
    toggleFit() {
      this.fit = !this.fit;
      if (this.fit) this.fitToMap();
      else this.fitToUserLocation();
    },
    shiftMapUpDown() {
      var y = -80; // down
      if (this.isTall) y = 80; // up
      this.map.panBy(new L.Point(0, y), { animate: true });
    },
    redrawMap() {
      this.map.invalidateSize();
      setTimeout(() => this.fitToMap(), 1000);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.mapID, { attributionControl: false });
      this.map.setView(this.pickup, 17);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        // minZoom: 12, << don't use min zoom anymore
        maxZoom: 19,
      }).addTo(this.map);

      this.map.zoomControl.remove();
      //   var position = { position: "bottomright" };
      //   L.control.zoom(position).addTo(this.map);

      this.layer = L.featureGroup().addTo(this.map);

      this.drawUserLocation();

      var pickupIcon = L.AwesomeMarkers.icon({
        icon: "street-view",
        markerColor: "blue",
      });

      var dropoffIcon = L.AwesomeMarkers.icon({
        icon: "flag-checkered",
        markerColor: "lightgreen",
        iconColor: "blue",
        extraClasses: "fa-lg",
      });

      // create markers, add to map and fit
      this.pickupMarker = L.marker(this.pickup, { icon: pickupIcon });
      this.pickupMarker.addTo(this.layer);
      this.dropoffMarker = L.marker(this.dropoff, { icon: dropoffIcon });
      this.dropoffMarker.addTo(this.layer);
      var group = new L.featureGroup([this.pickupMarker, this.dropoffMarker]);
      var padding = { padding: [50, 50] };
      this.map.fitBounds(group.getBounds(), padding);
      // this.shiftMapDown();

      // add popups
      var opts = { closeButton: false, autoPan: true }; // popupWide? popupNarrow?
      var pStr = this.$t("driver.pickup");
      var dStr = this.$t("driver.dropoff");
      var pickupName = this.pickup.name || this.$t("ride.pin-location");
      var dropoffName = this.dropoff.name || this.$t("ride.pin-location");
      this.pickupMarker.bindPopup(`<i>${pStr}</i><br>${pickupName}`, opts);
      this.dropoffMarker.bindPopup(`<i>${dStr}</i><br>${dropoffName}`, opts);

      if (this.t.state === "initiated") {
        setTimeout(() => this.pickupMarker.openPopup(), 1000);
        setTimeout(() => this.dropoffMarker.openPopup(), 3000);
        setTimeout(() => this.pickupMarker.openPopup(), 5000);
      }

      this.drawDriver();
    },
    drawUserLocation() {
      var coords = this.$store.getters.getUserLatLon;
      var icon = L.divIcon({
        html: `<div class="blue-dot"></div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      this.userMarker = L.marker(coords, { icon: icon });
      this.userMarker.addTo(this.layer);
      var popupOpts = { closeButton: false, autoPan: true };
      this.userMarker.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    fitToUserLocation() {
      this.map.setView(this.userMarker.getLatLng(), 16); // 15 = old town size
      //   setTimeout(() => this.userMarker.openPopup(), 1000);
    },
    fitToMap() {
      var padding = { padding: [60, 60] };
      this.map.fitBounds(this.layer.getBounds(), padding);
      //   setTimeout(() => this.userMarker.openPopup(), 1000);
    },
    // updateDriverMarker() {
    //   var coords = this.$store.getters.getUserLatLon;
    //   this.userMarker.setLatLng(coords);
    // },
    drawDriver() {
      if (this.t.state === "initiated") {
        if (this.driverMarker) {
          // in case driver had cancelled and it went back into state initiated
          this.layer.removeLayer(this.driverLine);
          this.layer.removeLayer(this.driverMarker);
        }
        return; // no driver at this state
      }
      // this.removeDriversForObserver(); // remove driver first if re-drawing?
      if (!this.t.driver) return; // this is normal for state initiated
      var ds = this.t.driver.user_state;
      if (ds.lat == 0) {
        console.warn("bad driver location!", ds);
        return;
      }
      if (!this.driverMarker) this.initialiseDriver(ds);

      if (this.t.state === "enroute" && this.driverLine) {
        this.layer.removeLayer(this.driverLine); // remove driver line
      }
      if (this.t.state === "alighted") return;
      this.driverMarker.slideTo([ds.lat, ds.lon], this.slideOpts);
      var profPic = this.profPic(this.t.driver);
      var img = `<img src=${profPic} style="object-fit: cover; height: 90px; width: 90px; border-radius:8px" />`;
      var driver = this.$t("driver.driver");
      var name = this.t.driver.name;
      var content = `<div style="width:90px">${img}<center><i>${driver}</i><br>${name}</center></div>`;
      this.driverMarker.bindPopup(content, this.popupNarrow);
      // if (this.t.state !== "enroute") {
      //   this.drawDriverToPickupLine();
      // }
    },
    // drawDriverToPickupLine() {
    //   var latlngs = Array();
    //   if (!this.driverLine) {
    //     if (!(this.pickupMarker && this.driverMarker)) return;
    //     latlngs.push(this.pickupMarker.getLatLng());
    //     latlngs.push(this.driverMarker.getLatLng());
    //     this.driverLine = L.polyline(latlngs, {
    //       color: "orange",
    //       opacity: 0.8,
    //       weight: "2",
    //       dashArray: "5, 6",
    //     }).addTo(this.layer);
    //     this.redrawLineOnZoom(this.driverLine);
    //   } else {
    //     latlngs.push(this.pickupMarker.getLatLng());
    //     latlngs.push(this.driverMarker.getLatLng());
    //     this.driverLine.setLatLngs(latlngs);
    //   }
    // },
    redrawLineOnZoom(line) {
      this.map.on("zoomend", () => line.redraw());
    },
    initialiseDriver(coords) {
      var icon = L.divIcon({
        html: `<div class='driver-circle'><img src='${this.vehicleIcon}' /></div>`,
        popupAnchor: [-4, -26],
        className: "none",
      });
      this.driverMarker = L.marker(coords, { icon: icon });
      this.driverMarker.addTo(this.layer);
      this.driverMarker.on("click", () => this.checkDriverGPS());
    },
    checkDriverGPS() {
      var ds = this.t.driver.user_state;
      //   var updatedAt = new Date(ds.updated_at);
      //   var seconds = (new Date().getTime() - updatedAt.getTime()) / 1000;
      var seconds = this.secondsAgo(ds.updated_at); // returns seconds ago int
      var remindedSeconds = this.secondsAgo(this.driverGPSRemindedAt);
      //   console.log("check driver gps", seconds, remindedSeconds);
      if (seconds < 90 || remindedSeconds < 45) return;
      this.driverGPSRemindedAt = new Date();
      var msg = "ลูกค้าตรวจสอบ GPS ของคุณ 🧭"; // customer is checking your GPS
      this.sendPushNotification(msg, this.t.driver.id);
    },
    watchUserLocation() {
      this.$store.subscribe((mutation) => {
        if (mutation.type === "setUserState") {
          if (this.userMarker) this.updateUserMarker();
        }
      });
    },
    recenter() {
      this.spin = true;
      setTimeout(() => (this.spin = false), 600);
      this.updateUserMarker();
      this.centerUserMarker(true);
      setTimeout(() => this.userMarker.openPopup(), 1000);
    },
    centerUserMarker(flyTo) {
      var coords = this.userMarker.getLatLng();
      if (flyTo) this.map.flyTo(coords);
      else this.map.setView(coords, 17);
    },
    updateUserMarker() {
      if (!this.userMarker) return;
      var coords = this.$store.getters.getUserLatLon;
      this.userMarker.setLatLng(coords);
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  position: absolute;
  top: 0;
  height: calc(100vh - 285px);
  width: 100vw;
  z-index: 0;
}
/* .is-tall {
  height: calc(100vh - 400px);
} */
.map {
  position: relative;
  height: 100%;
  width: 100%;
}
.center-btn.button {
  margin: 10px;
  margin-left: 0;
  padding: 0 9px;
  pointer-events: auto;
  /* color: rgb(0, 106, 255); */
  color: #777;
  box-shadow: 1px 1px 4px grey;
}
</style>

<style lang="scss">
#ride-booking-map-map {
  .leaflet-control-locate {
    border-radius: 50%;
  }
  .leaflet-control-locate a {
    border-radius: 50%;
  }
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    // color: rgb(23, 23, 193);
    color: rgb(23, 102, 193);
    font-size: 1.2em;
    max-width: 130px;
  }
  .leaflet-popup-content i {
    font-weight: 500;
    opacity: 0.8;
    color: grey;
  }
  .blue-dot {
    margin-left: 6px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
    animation: pulsate-2 3s ease-out infinite;
  }
  .driver-circle {
    height: 43px;
    width: 43px;
    border-radius: 50%;
    padding: 4px;
    transform: translateX(-50%) translateY(-50%);
    filter: drop-shadow(2px 2px 2px #555);
    background-color: rgba(255, 255, 0, 0.7);
    border: 0.5px solid rgba(128, 128, 128, 0.579);
    animation: shadow-pulse 1.5s ease-out infinite;
  }
  @keyframes shadow-pulse {
    0% {
      box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
    }
    100% {
      box-shadow: 0 0 0 9px rgba(247, 211, 8, 0);
    }
  }
  .driver-circle img {
    height: 30px;
    width: 30px;
    filter: drop-shadow(1px 1px 1px #555);
  }
  @keyframes pulsate-2 {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
  //   @-webkit-keyframes pulsate-2 {
  //     0% {
  //       box-shadow: 0 0 0 1px cyan;
  //     }
  //     50% {
  //       box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
  //     }
  //     100% {
  //       box-shadow: 0 0 0 1px lightskyblue;
  //     }
  //   }
}
</style>